module.exports = __webpack_public_path__ + "img/7.0_News_8_Grog-App@2x.3d8c7b2849e3b61574e9b0772f03a00b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/7.0_News_8_Grog-App@2x.png
// module id = 800
// module chunks = 0